import React from 'react';
import ImageUploading, { ImageListType } from 'react-images-uploading';

import './review-image-upload-style.scss';
import { useSnackbar } from '@src/providers/SnackbarProvider';

import Typography from '@src/componentsNew/Typography/Typography';

import PhotoIcon from '@src/componentsNew/Icons/Icons/PhotoIcon';
import CloseIcon from '@src/componentsNew/Icons/Icons/CloseIcon';
import InfoIcon from '@src/componentsNew/Icons/Icons/InfoIcon';

const ReviewImageUpload = ({ images, setImages, maxNumber }) => {
  const maxFileSize = 10 * 1024 * 1024; // 10MB
  const { showSnackbar } = useSnackbar();

  const onChange = (imageList: ImageListType, addUpdateIndex: number[] | undefined) => {
    const imageListTotalFileSize = imageList.reduce((totalSize, currentImage) => totalSize + currentImage.file.size, 0);

    if (imageListTotalFileSize > maxFileSize) {
      showSnackbar({ message: 'Images must not exceed 10MB' });

      return;
    }

    setImages(imageList as never[]);
  };

  const onError = (errors, files) => {
    if (errors.maxNumber) {
      showSnackbar({ message: 'Up to 5 images can be uploaded' });
    }

    if (errors.maxFileSize) {
      showSnackbar({ message: 'Images must not exceed 10MB' });
    }
  };

  return (
    <ImageUploading
      multiple
      value={images}
      onChange={onChange}
      onError={onError}
      acceptType={['jpg', 'png', 'jpeg']}
      maxFileSize={maxFileSize}
      maxNumber={maxNumber}
    >
      {({ imageList, onImageUpload, onImageRemove, isDragging, dragProps }) => (
        <div className="image-upload-container">
          <div className="image-upload-area" onClick={onImageUpload} {...dragProps}>
            <div className="photo-icon-wrapper">
              <PhotoIcon />
              <Typography cName="title-result-text" variant="body3" component="p" style={{ color: '#0288D1' }}>
                Add Photo
              </Typography>
            </div>

            <div className="review-reward-point-text-wrapper">
              <InfoIcon />

              <Typography variant="caption" component="p" style={{ color: '#666666' }}>
                Currently, points not being awarded for writing reviews
              </Typography>
            </div>
          </div>
          {imageList?.length ? (
            <ul className="uploaded-images-preview-area">
              {imageList.map((image, index) => (
                <li key={index} className="upload-image-wrapper">
                  <div className="upload-image-item">
                    <img src={image.dataURL} alt="" width="100" />
                    <div className="remove-item-btn" onClick={() => onImageRemove(index)}>
                      <CloseIcon width="20" height="20" />
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      )}
    </ImageUploading>
  );
};

export default ReviewImageUpload;
